import React from 'react'

const DocumentsContext = React.createContext({})
export const DocumentsProvider = DocumentsContext.Provider
export default DocumentsContext
